<template>
  <table
    class="border-collapse w-full"
    :class="layout === 'fixed' ? 'table-fixed' : 'table-auto'"
  >
    <thead>
      <tr>
        <slot name="header" />
      </tr>
    </thead>
    <tbody>
      <slot />
    </tbody>
  </table>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'Table',
  props: {
    layout: {
      type: String as PropType<'auto' | 'fixed'>,
      default: 'auto',
    },
  },
})
</script>
